const SET_SITE_DISPLAY_NAME = 'set-site-display-name';

export { SET_SITE_DISPLAY_NAME };
